




























































































































































import {
  defineComponent,
  ref,
  useContext,
  watch,
} from '@nuxtjs/composition-api';
import type { PropType } from '@nuxtjs/composition-api';
import { IBlokSingleImage } from '~/components/storyblok/SingleImage.vue';
import { SfCarousel, SfCarouselItem } from '~/components/StorefrontUi';
import { addBasePath } from '~/helpers/addBasePath';
import SkeletonLoader from '~/components/SkeletonLoader/index.vue';
import useUser from '~/modules/customer/composables/useUser';

interface ISlide {
  _uid: string;
  banner: IBlokSingleImage[];
  // eslint-disable-next-line no-undef
  link: SbLink
  isOnlyForB2B: boolean;
}

interface IBlok {
  _uid: string;
  slide: ISlide[];
}

export default defineComponent({
  name: 'SliderMainBlok',
  components: {
    SfCarousel,
    SkeletonLoader,
    SfCarouselItem,
    Modal: () => import('~/components/Modal.vue'),
  },
  props: {
    blok: {
      type: Object as PropType<IBlok>,
      required: true,
    },
  },
  setup({ blok }: { blok: IBlok }) {
    const { isB2bUser } = useUser();
    const { app, $navigateToPage, $localeSbUrl } = useContext();
    const carouselRef = ref(null);
    // set to -1 to show progress animation on first slide after mount
    const activeIndex = ref(-1);
    const isModalOpen = ref(false);
    const viewedBanners = ref([]);

    const goToSpecificSlide = (slideId: number) => {
      carouselRef.value.goToSlide(slideId + 1);
    };

    const closeModal = () => {
      isModalOpen.value = false;
    };

    watch(
      // eslint-disable-next-line consistent-return
      () => {
        if (carouselRef.value && carouselRef.value.glide) {
          return carouselRef.value.glide.index;
        }
      },
      (newVal, oldVal) => {
        if (newVal !== oldVal) {
          activeIndex.value = newVal;
        }
      },
    );

    const getBannerForDL = (banner, order) => {
      const {
        promotionName, promotionStart, promotionEnd, _uid: id,
      } = banner;
      const alt = banner?.banner[0]?.Alt || '';
      const url = $localeSbUrl({ slug: banner.link.cached_url });
      return {
        promotion_name: promotionName,
        banner: {
          id,
          from: promotionStart,
          to: promotionEnd,
          urlDesktop: url,
          alt,
          order,
        },
      };
    };

    const pushToUrl = (banner, order) => {
      const { link } = banner;
      const bannerForDL = getBannerForDL(banner, order);
      app.$googleTagManager.promoClick(bannerForDL);
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      $navigateToPage(link);
    };

    const { slide } = blok;

    const filteredSlides = slide.filter(
      (s) => !s.isOnlyForB2B || isB2bUser.value,
    );

    const isSingleSlide = filteredSlides.length === 1 && filteredSlides[0].banner.length === 1;
    const noSlides = !blok || !filteredSlides || filteredSlides?.length === 0;

    const onVisibilityChange = (isVisible, entry, banner, index) => {
      // eslint-disable-next-line no-underscore-dangle
      const bannerUid = banner._uid;
      if (isVisible && !viewedBanners.value.includes(bannerUid)) {
        app.$googleTagManager.promo(getBannerForDL(banner, index));
        viewedBanners.value.push(bannerUid);
      }
    };

    return {
      onVisibilityChange,
      slide,
      filteredSlides,
      pushToUrl,
      carouselRef,
      activeIndex,
      isSingleSlide,
      goToSpecificSlide,
      noSlides,
      // Modal
      isModalOpen,
      closeModal,
    };
  },
  methods: { addBasePath },
});
